import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from '../ui/Button';
import { useAuth } from './AuthenticationGuard';

const AdminNavigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut, userProfile } = useAuth();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location?.pathname]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const handleSignOut = async () => {
    await signOut();
  };

  const navigationItems = [
    { label: 'Dashboard', path: '/admin-dashboard', icon: 'LayoutDashboard' },
    { label: 'Posts', path: '/admin-posts-management', icon: 'FileText' },
    { label: 'New Post', path: '/admin/posts/new', icon: 'PenSquare' },
    { label: 'Users', path: '/admin/users', icon: 'Users' },
    { label: 'Design System', path: '/admin/design-system', icon: 'Palette' }
  ];

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  return (
    <>
      <nav className="admin-navigation">
        <div className="admin-navigation-container">
          <Link to="/admin-dashboard" className="admin-navigation-logo">
            <div className="admin-navigation-logo-icon">
              <Icon name="Shield" size={24} color="var(--color-secondary)" />
            </div>
            <span className="admin-navigation-logo-text">Sleeve Admin</span>
          </Link>

          <div className="admin-navigation-menu">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`admin-navigation-link ${isActivePath(item?.path) ? 'active' : ''}`}
              >
                <Icon name={item?.icon} size={18} color="currentColor" />
                {item?.label}
              </Link>
            ))}
            <div className="flex items-center gap-3">
              <div className="hidden md:flex items-center gap-2 px-3 py-2 rounded-lg" style={{ background: 'var(--color-muted)' }}>
                <Icon name="User" size={16} color="var(--color-primary)" />
                <span className="text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
                  {userProfile?.full_name || userProfile?.email}
                </span>
                {userProfile?.role && (
                  <span className="text-xs px-2 py-0.5 rounded" style={{ background: 'rgba(245, 203, 92, 0.2)', color: 'var(--color-secondary)' }}>
                    {userProfile?.role}
                  </span>
                )}
              </div>
              <Button
                variant="ghost"
                size="sm"
                iconName="LogOut"
                iconPosition="left"
                onClick={handleSignOut}
              >
                Sign Out
              </Button>
            </div>
          </div>

          <button
            className="admin-navigation-mobile-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            <Icon 
              name={isMobileMenuOpen ? 'X' : 'Menu'} 
              size={24} 
              color="var(--color-foreground)" 
            />
          </button>
        </div>
      </nav>
      {isMobileMenuOpen && (
        <div className="admin-navigation-mobile-menu animate-fade-in">
          <div className="admin-navigation-mobile-menu-list">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`admin-navigation-mobile-link ${isActivePath(item?.path) ? 'active' : ''}`}
              >
                <Icon name={item?.icon} size={20} color="currentColor" />
                {item?.label}
              </Link>
            ))}
            <button
              onClick={handleSignOut}
              className="admin-navigation-mobile-link"
            >
              <Icon name="LogOut" size={20} color="currentColor" />
              Logout
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminNavigation;